var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"miss-count"},[_vm._v("Miss: "+_vm._s(_vm.state.missCount))])
}
var staticRenderFns = []

export { render, staticRenderFns }